// Hero/index.tsx
import { useTranslation } from "react-i18next"
import { Layout, HeroContainer, BackgroundImage, Content, Title, Subtitle, Description } from "./Style"

const Hero: React.FC = () => {
  const { t } = useTranslation("vipGuests/hero")

  return (
    <Layout>
      <HeroContainer>
        <BackgroundImage />
        <Content>
          <Title>{t("title")}</Title>
          <Subtitle>{t("subtitle")}</Subtitle>
          <Description>{t("description")}</Description>
        </Content>
      </HeroContainer>
    </Layout>
  )
}

export default Hero
